import {
  useCallback,
  useLayoutEffect,
  useReducer,
} from 'react';
import type { GPModalsVariants } from './gatorProtectModalsVisibilityReducer';
import {
  clearedModalsAvailability,
  gpModalControllerReducer,
} from './gatorProtectModalsVisibilityReducer';

export type HideGatorProtectModalSlot = (_modal: GPModalsVariants) => void;

/**
 * Single reducer-backed controller (`GPAvailableModals` + `RESTORE_ALL_MODALS` / `SET_MODAL`).
 * Modal hooks call `hide(variant)`; eligibility slots come from `availableModals` in `GatorProtectGlobals`.
 */
export function useGatorProtectModalsVisibility() {
  const [availableModals, dispatch] = useReducer(
    gpModalControllerReducer,
    clearedModalsAvailability,
  );

  useLayoutEffect(() => {
    dispatch({ type: 'RESTORE_ALL_MODALS' });
  }, []);

  const setModalVisible = useCallback((modal: GPModalsVariants, visible: boolean) => {
    dispatch({ type: 'SET_MODAL', modal, visible });
  }, []);

  const hide = useCallback<HideGatorProtectModalSlot>((modal) => {
    setModalVisible(modal, false);
  }, [setModalVisible]);

  const resetAll = useCallback(() => {
    dispatch({ type: 'RESTORE_ALL_MODALS' });
  }, []);

  return {
    availableModals,
    hide,
    resetAll,
  };
}
